import {Select} from 'antd'
import classNames from 'classnames'
import filterOption from 'helpers/filterOption'
import Translate from 'modules/local/Translate'
import React, {useEffect, useRef, useState} from 'react'
import {FaCaretDown} from 'react-icons/fa'
import {NullAsDefault} from 'views/Shared'

const IndicatorsContainer = ({ children }) => (
    <div
        className="flex items-center"
        style={{
            padding: '0 8px',
        }}>
        {children}
    </div>
)

const DropdownIndicator = () => (
    <FaCaretDown
        style={{
            color: 'var(--text-color-500)',
            marginLeft: '8px',
        }}
    />
)

/**
 * Wraps children in a mounted guard so that any descendant (e.g. Translate)
 * that tries to setState after unmount becomes a no-op instead of leaking.
 */
const MountedGuard = ({ children }) => {
    const [mounted, setMounted] = useState(true)
    const isMounted = useRef(true)

    useEffect(() => {
        isMounted.current = true
        return () => {
            isMounted.current = false
            // Defer the state update so React doesn't warn about batching
            setMounted(false)
        }
    }, [])

    if (!mounted) return null
    return children
}

const DefaultEmptyHolder = React.memo(() => (
    <MountedGuard>
        <Translate>{(t) => <div>{t('no data is available now')}</div>}</Translate>
    </MountedGuard>
))

export const reactSelectOnTop = {
    styles: {
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    },
    menuPortalTarget: document.body,
    noOptionsMessage: () => <DefaultEmptyHolder />,
}

export const dropdownComponents = {
    DropdownIndicator,
    IndicatorsContainer,
    LoadingIndicator: NullAsDefault,
}

export const reactSelectComponents = {
    DropdownIndicator,
    IndicatorsContainer,
    IndicatorSeparator: NullAsDefault,
    LoadingIndicator: NullAsDefault,
}

export const SelectWidget = React.forwardRef(
    ({ className, suffixIcon = <DropdownIndicator />, options, value, children, ...props }, ref) => {
        const hasOptions = (Array.isArray(options) && options.length > 0) || !!children
        return (
            <Select
                ref={ref}
                onTouchStart={e => e.stopPropagation()}
                suffixIcon={!!props?.loading ? undefined : suffixIcon}
                filterOption={filterOption}
                className={classNames('SelectWidget custom-select-widget', className)}
                options={options}
                value={hasOptions ? value : undefined}
                {...props}
            >
                {children}
            </Select>
        )
    }
)

export const SelectDropdownIndicator = DropdownIndicator